<template>
  <div class="ml-3">
    <div class="ml-2 mb-2">
      <span class="orange-icon orange-icon-badge-align fa fa-info-circle" />
      <strong class="py-2 pl-2 font-16">Ajustes</strong>
    </div>
    <validation-observer ref="adjustForm" v-slot="{}" tag="form">
      <div class="row mt-2 mb-2 pr-4 pl-2 pt-3 pb-3">
        <div class="col-md-2">
          <div class="adjust-align">
            <span class="data-title d-block border-mobile">Nivel:</span>

            <custom-radio-button
              id="CustomRadioTypeNivel"
              v-model="isSummary"
              custom-error-msg="El nivel es requerido."
              :is-disabled="false"
              is-inline
              :name="`${data.contractId}level`"
              :options="visitOptions"
            />
          </div>
        </div>

        <div v-if="!isSummary" class="col-md-5">
          <span class="data-title d-block border-mobile">Fecha de Visita:</span>
          <validation-provider
            v-slot="{ errors }"
            name="customDropDownReason"
            rules="required"
          >
            <custom-drop-down
              id="bill-change-status-dropdown-status"
              v-model="visitDateSelected"
              :clearable="false"
              custom-error-msg="La fecha es requerida."
              :error="errors[0]"
              fieldkey="visitId"
              fieldname="visitDate"
              :options="visitDates"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-2 mb-2 pr-4 pl-2 pt-3 pb-3">
        <div v-if="!isSummary" class="col-md-6">
          <!-- <validation-provider v-slot="{ errors }" name="customDropDownReason2" rules="required"> -->
          <span class="data-title d-block border-mobile">Razón:</span>
          <custom-drop-down
            id="bill-change-status-dropdown-status"
            v-model="visitReasonSelected"
            :clearable="false"
            fieldkey="id"
            fieldname="name"
            :options="availableReasons"
            placeholder="Seleccione"
          />
          <!-- </validation-provider> -->
        </div>
        <div v-if="!isSummary" class="col-md-2 mt-1">
          <action-button
            id="actionBtnAddVisitReason"
            i="fas fa-file-plus fa-lg pl-2 mt-1 mb-1"
            text="Añadir"
            variant="success mt-4 mb-4  pr-3 pl-2"
            @click="addVisitReason"
          />
        </div>
        <div v-if="isSummary" class="col-md-6">
          <span class="data-title d-block border-mobile">Razón:</span>

          <custom-drop-down
            id="bill-change-status-dropdown-status"
            v-model="visitReasonSelected"
            :clearable="false"
            fieldkey="id"
            fieldname="name"
            :options="availableReasons"
            placeholder="Seleccione"
          />
          <action-button
            id="actionBtnAddVisitReason"
            i="fas fa-file-plus fa-lg pl-2 mt-1 mb-1"
            text="Añadir"
            variant="success mt-4 mb-4  pr-3 pl-2"
            @click="addVisitReason"
          />
        </div>
        <div class="col-md-12">
          <template>
            <div class="row">
              <custom-chips-group
                class="refNumbers"
                no-background
                object-id="id"
                object-title="name"
                :on-item-deleted="onDeleteReasons"
                :selected-items="selectedReasons"
                title=""
              />
            </div>
          </template>
        </div>
      </div>
      <div class="row mt-2 mb-3 pl-2 pr-4">
        <div class="col-md-2">
          <div class="adjust-align">
            <validation-provider
              v-slot="{ errors }"
              name="CustomRadioAdjustType"
              rules="required"
            >
              <span class="data-title d-block border-mobile">
                ¿Que tipo de ajuste desea realizar?
              </span>
              <custom-radio-button
                id="CustomRadioTypeAdjust"
                v-model="isIncrement"
                custom-error-msg="El tipo de ajuste es requerido."
                :error="errors[0]"
                :is-disabled="false"
                is-inline
                :name="`${data.contractId}+-`"
                :options="adjustmentOptions"
              />
            </validation-provider>
          </div>
        </div>
        <div class="col-md-5">
          <span class="data-title d-block border-mobile">Cantidad:</span>
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              greaterThanZero: 'La cantidad debe ser mayor que 0.',
              required: 'La cantidad es requerida.',
            }"
            name="customInputQuantity"
            rules="required|greaterThanZero"
          >
            <custom-input
              id="txtQuantityBudget"
              v-model="adjustmentAmount"
              :error="errors[0]"
              :icon-background-class="
                isIncrement
                  ? 'adjust-background-green'
                  : 'adjust-background-red'
              "
              placeholder="$0.00"
              :prepend-icon="
                isIncrement
                  ? 'fas fa-plus icon-color icon-font'
                  : 'fas fa-minus icon-color icon-font'
              "
              :prepend-icon-left="true"
              type="number"
            />
          </validation-provider>
        </div>
        <div class="col-md-5">
          <span class="data-title d-block border-mobile">Comentario:</span>
          <validation-provider
            v-slot="{ errors }"
            name="customInputComment"
            rules="required"
          >
            <custom-input
              id="bill-change-status-input-comment"
              v-model="comment"
              class="custom-input-con"
              custom-error-msg="El comentario es requerido."
              :error="errors[0]"
              maxlength="3000"
            />
          </validation-provider>
        </div>
        <div
          class="col-md-12 col-sm-12 d-flex justify-content-end align-items-center"
        >
          <div class="align-button-group">
            <action-button
              id="actionBtnCancelDocumentSigned"
              i="fas fa-times-circle  pl-2"
              text="Cancelar"
              variant="outline-danger mr-2 mt-4 mb-4 pr-3 pl-2"
              @click="cancelAdjustment"
            />
            <action-button
              id="actionBtnDownSavedDocumentSigned"
              i="fas fa-save fa-lg pl-2 mt-1 mb-1"
              text="Guardar"
              variant="success mt-4 mb-4  pr-3 pl-2"
              @click="saveAdjustment"
            />
          </div>
        </div>
      </div>
    </validation-observer>
    <div v-if="Object.keys(adjustmentsSeparatedData).length">
      <adjustment-separated
        ref="adjustmentSeparatedRef"
        class="w-100"
        :data="adjustmentsSeparatedData"
        @accept="handleAcceptRecommendedAdjustment"
        @delete="handleDeleteAppliedAdjustment"
        @reject="handleRejectRecommendedAdjustment"
        @revert-rejected="handleReverRejectedRecommendedAdjustment"
        @selected="getAdjustmentsSeparated"
      />
    </div>
  </div>
</template>

<script>
import CustomRadioButton from 'custom-radio';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import servicesTypes from '@/utils/constants/serviceTypes.js';
import billingLevels from '@/utils/constants/billingLevels.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import {
  getVisitDates as _getVisitDates,
  getAdjustmentReasons as _getAdjustmentReasons,
  getAdjustmentsSeparated as _getAdjustmentsSeparated,
  saveAdjustment as _saveAdjustment,
  deleteAdjustment as _deleteAdjustment,
  updateAdjustmentRecommendedStatus as _updateAdjustmentRecommendedStatus,
} from '@/services/provider/billing-contract.api';
import { numberMixin } from '@/mixins/number.mixin';
import billingStatus from '@/utils/constants/billingStatus';
import rpAIAdjustmentRecommendationStatus from '@/utils/constants/rpAIAdjustmentRecommendationStatus.js';
import CustomChipsGroup from 'CustomChipsGroup';
// child components
import AdjustmentSeparated from './AdjustmentSeparated.vue';
export default {
  name: 'Adjustment',
  mixins: [alertMixin, numberMixin],
  components: {
    CustomRadioButton,
    CustomDropDown,
    CustomInput,
    ActionButton,
    AdjustmentSeparated,
    CustomChipsGroup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    bill: {
      type: Object,
      required: true,
    },
    selectAdjustmentRecommendationTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reasonSelected: null,
      adjustmentAmount: null,
      isSummary: false,
      isIncrement: false,
      visitOptions: [
        {
          name: 'Resumen',
          label: 'Resumen',
          value: true,
        },
      ],
      selectedReasons: [],
      adjustments: [],
      adjustmentsSeparatedData: {},
      visitDates: [],
      visitDateSelected: null,
      visitReasons: [],
      visitReasonSelected: null,
      comment: null,
    };
  },
  async mounted() {
    this.showVisitOption();
    await Promise.all([
      this.getVisitDates(),
      this.getAdjustmentsSeparated(),
    ]).then(() => this.getAdjustmentReasons());

    this.$nextTick(() => {
      if (this.selectAdjustmentRecommendationTab) {
        this.$refs.adjustmentSeparatedRef?.setSelectedIndex(1);
      }
    });
  },
  computed: {
    canViewOpcionPositiveAdjustments() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.positiveadjustments'
      );
    },
    adjustmentOptions() {
      let options = [{ name: 'groupName2', label: 'Negativo', value: false }];
      if (this.canViewOpcionPositiveAdjustments) {
        options.unshift({ name: 'groupName2', label: 'Positivo', value: true });
      }
      return options;
    },
    levels() {
      return billingLevels;
    },
    availableReasons() {
      const adjustmentReasonIds = this.adjustments.map(
        (x) => x.adjustmentReasonId
      );
      const selectedReasonsId = this.selectedReasons.map((x) => x.id);

      return this.visitReasons.filter(
        (x) =>
          !adjustmentReasonIds.includes(x.id) &&
          !selectedReasonsId.includes(x.id)
      );
    },
    canDeleteAdjustment() {
      //Status and Permission
      let canDelete =
        this.userHasPermissions(
          'rempro.providers.billinghistory.removeadjustment'
        ) && this.bill.statusId == billingStatus.EnProcesoIntervencion;

      return (
        canDelete ||
        this.userHasPermissions(
          'rempro.providers.billinghistory.manualremoveAdjustment'
        )
      );
    },
  },
  methods: {
    async getVisitDates() {
      await _getVisitDates({
        contractId: this.data.contractId,
        academicYearId: this.data.academicYearId,
        monthNumber: this.data.monthNumber,
      }).then(
        ({ data }) =>
          (this.visitDates = data.map((x) => ({
            visitId: x.visitId,
            visitDate: this.$formatDate(x.visitDate),
          })))
      );
    },
    async getAdjustmentReasons() {
      await _getAdjustmentReasons().then(
        ({ data }) => (this.visitReasons = data)
      );
    },
    async getAdjustmentsSeparated() {
      const response = await _getAdjustmentsSeparated(
        this.bill.billId,
        this.data.contractId,
        this.data.visitSummaryId
      );
      if (response?.data) {
        this.adjustmentsSeparatedData = response.data;
      }
    },
    addVisitReason() {
      if (this.visitReasonSelected) {
        this.selectedReasons.push(this.visitReasonSelected);
        this.visitReasonSelected = null;
      } else {
        this.ShowToast(
          'Alerta',
          'Debe seleccionar una razón para agregarla al ajuste',
          'warning'
        );
      }
    },
    onDeleteReasons(item) {
      this.selectedReasons = this.selectedReasons.filter((r) => r != item);
    },
    showVisitOption() {
      if (
        this.data.serviceTypeId === servicesTypes.Therapy ||
        this.data.serviceTypeId === servicesTypes.Assistant
      ) {
        this.visitOptions = [
          {
            name: 'Visita',
            label: 'Visita',
            value: false,
          },
          {
            name: 'Resumen',
            label: 'Resumen',
            value: true,
          },
        ];
      } else {
        this.isSummary = true;
      }
    },
    clean() {
      this.isSummary = false;
      this.visitDateSelected = null;
      this.visitReasonSelected = null;
      this.isIncrement = false;
      this.adjustmentAmount = null;
      this.comment = null;
      this.selectedReasons = [];
      this.$refs.adjustForm.reset();
    },
    cancelAdjustment() {
      this.clean();
      this.$emit('on-cancel-adjustment');
    },
    async saveAdjustment() {
      const isValid = await this.$refs.adjustForm.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      if (this.selectedReasons.length == 0) {
        this.ShowToast(
          'Alerta',
          'Debe tener al menos una razón agregada',
          'error'
        );
      }
      const selectedReasonPayload = this.selectedReasons.map((x) => ({
        id: x.id,
        name: x.name,
      }));

      const payload = {
        billId: this.bill.billId,
        visitId: this.visitDateSelected?.visitId,
        visitSummaryId: this.isSummary ? this.data.visitSummaryId : null,
        AdjustmentReasons: selectedReasonPayload,
        amount: this.isIncrement
          ? Number(this.adjustmentAmount)
          : Number(this.adjustmentAmount) * -1,
        comment: this.comment,
        transactionTypeId: this.isSummary
          ? this.levels.summary
          : this.levels.visit,
        attachment: null,
      };
      payload.amount = this.decimalNumberToOnlyTwoDigits(payload.amount);
      //Convert payload to formData
      const formData = new FormData();
      Object.keys(payload).forEach((key) => {
        formData.append(key, payload[key]);
      });
      await _saveAdjustment(payload)
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso.',
            'El ajuste se ha guardado exitosamente.',
            'success'
          );

          this.clean();
          this.getAdjustmentsSeparated();
          this.$root.$emit('reload-billing-statuses');

          // select applied adjustments tab
          if (this.$refs?.adjustmentSeparatedRef) {
            this.$refs.adjustmentSeparatedRef?.setSelectedIndex(0);
          }
        })
        .catch((err) =>
          this.ShowToast('', err.response?.data?.message, 'error')
        );
    },

    async deleteAdjustment(item) {
      await _deleteAdjustment(item.adjustmentId)
        .then(async () => {
          this.ShowToast(
            'Proceso Exitoso.',
            'El ajuste se ha eliminado exitosamente.',
            'success'
          );

          this.clean();
          await this.getAdjustmentsSeparated();
          this.$root.$emit('reload-billing-statuses');
        })
        .catch((err) =>
          this.ShowToast('', err.response?.data?.message, 'error')
        );
    },
    async updateAdjustmentRecommendedStatus(item) {
      const payload = {
        billId: this.bill.billId,
        visitSummaryId: this.data.visitSummaryId,
        adjustmentRecommendationId: item.adjustmentRecommendationId,
        AdjustmentRecommendationStatusId: item.adjustmentRecommendationStatusId,
      };

      const response = await _updateAdjustmentRecommendedStatus(
        payload
      ).catch((err) =>
        this.ShowToast('', err.response?.data?.message, 'error')
      );

      if (response?.data) {
        await this.getAdjustmentsSeparated();
      }

      return response;
    },
    async handleDeleteAppliedAdjustment(item) {
      if (item.isAdjustmentRecommendation) {
        item.adjustmentRecommendationStatusId = null;
        const response = await this.updateAdjustmentRecommendedStatus(item);
        if (response?.data) {
          this.ShowToast(
            'Proceso Exitoso.',
            'El ajuste se ha eliminado exitosamente.',
            'success'
          );
        }
      } else {
        await this.deleteAdjustment(item);
      }
    },
    async handleAcceptRecommendedAdjustment(item) {
      item.adjustmentRecommendationStatusId =
        rpAIAdjustmentRecommendationStatus.Accepted;
      const response = await this.updateAdjustmentRecommendedStatus(item);
      if (response?.data) {
        this.ShowToast(
          'Proceso Exitoso.',
          'El ajuste se ha aceptado exitosamente.',
          'success'
        );
      }
    },
    async handleRejectRecommendedAdjustment(item) {
      item.adjustmentRecommendationStatusId =
        rpAIAdjustmentRecommendationStatus.Rejected;
      const response = await this.updateAdjustmentRecommendedStatus(item);
      if (response?.data) {
        this.ShowToast(
          'Proceso Exitoso.',
          'El ajuste se ha rechazado exitosamente.',
          'success'
        );
      }
    },
    async handleReverRejectedRecommendedAdjustment(item) {
      item.adjustmentRecommendationStatusId = null;
      const response = await this.updateAdjustmentRecommendedStatus(item);
      if (response?.data) {
        this.ShowToast(
          'Proceso Exitoso.',
          'El rechazo del ajuste se ha revertido exitosamente.',
          'success'
        );
      }
    },
  },
};
</script>

<style lang="scss">
.adjust-align {
  width: 109%;
}

.custom-input-con ::v-deep {
  .form-control {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #c5cdcf;
    opacity: 1;
    height: 41px;
  }
}

.container-ajust-budget {
  background-color: white;
  border-radius: 5px;
}

.positive {
  color: #2db782;
}

.negative {
  color: red;
}

.adjust-background-green {
  background-color: var(--green);
}

.adjust-background-red {
  background-color: var(--red);
}

.icon-font {
  color: var(--white);
  font-weight: 400;
}

.label-gray {
  color: #727272;
}

.container-text-aviable {
  margin-left: 45%;
}

.container-buttons {
  margin-left: 228px;
}

.comments {
  width: 50%;
}
</style>
